module.exports = __webpack_public_path__ + "imgs/product-new.a560806ec9a11f1e4d9fb43adbc7d281.svg";